import { z } from "zod";
import { selfCertQSchema } from "@features/account/model/selfCertQ.model";

export const selfCertResponseSchema = z.object({
  q: selfCertQSchema,
});

export type SelfCertResponseType = z.infer<typeof selfCertResponseSchema>;
